import {
  Button,
  IconButton,
  Input,
  InputAdornment,
  Snackbar,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tabs,
  TextField,
} from "@material-ui/core";
import CreateIcon from "@material-ui/icons/Create";
import DeleteIcon from "@material-ui/icons/Delete";
import DescriptionIcon from "@material-ui/icons/Description";
import React, { useEffect, useRef, useState } from "react";
import useApi from "../../../../../../../hooks/api/index";
import {
  formatCurrency,
  sanitizeDocumentName,
} from "../../../../../../../utils/formatters";
import Alert from "../../../../../../ui/alert";

export default ({ trade }) => {
  const { precatorio, contacts, nome_credor } = trade;
  const { documentos, eventos } = precatorio;

  const [contactDisplay, setContactDisplay] = useState(contacts);

  const [emailList, setEmailList] = useState([]);
  const [mobileList, setMobileList] = useState([]);
  const [wireList, setWireList] = useState([]);
  const [contactUpdated, setContactUpdated] = useState(false);
  const [updateError, setUpdateError] = useState(false);

  const emailRef = useRef();
  const mobileRef = useRef();
  const wireRef = useRef();

  const { del, post } = useApi();

  const [currentTab, setCurrentTab] = useState(0);
  const handleChange = (_, newVal) => setCurrentTab(newVal);

  const deleteContact = async (id) => {
    try {
      const response = await del(`v1/crm/trades/${trade.id}/contacts/${id}`);

      setContactDisplay(response.data);
      setEmpty();
      setContactUpdated(true);
    } catch {
      setUpdateError(true);
    }
  };

  const addContact = async (type, ref) => {
    const userInput = ref.current.value;

    try {
      const dataInput = {
        contact: {
          data_type: type,
          data: userInput,
        },
      };

      const response = await post(
        `v1/crm/trades/${trade.id}/contacts`,
        dataInput
      );

      setContactDisplay(response.data);
      setContactUpdated(true);
    } catch {
      setUpdateError(true);
    }
  };

  const createRow = (key, formatter) => {
    const { label, value } = precatorio[key];

    return (
      <TableRow className="crm-trade-card-field">
        <TableCell className="m-bold-600">{label}: </TableCell>

        <TableCell>
          {formatter ? formatter.call(null, value) : value || "Não disponível"}
        </TableCell>
      </TableRow>
    );
  };

  const contactLabel = (type) => {
    let l;

    switch (type) {
      case "wired":
        l = "Telefone fixo";
        break;
      case "mobile":
        l = "Telefone celular";
        break;
      default:
        l = "Email";
        break;
    }

    return l;
  };

  const contactsData = (list, type, ref) => {
    const label = contactLabel(type);
    const isPhoneNumber = type !== "email";

    return (
      <div className="crm-details-contacts-area">
        <p className="crm-trade-basic-title">{label}</p>

        {list.map(({ data, id }, i) => {
          return (
            <Input
              variant="outlined"
              key={id}
              value={data}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    id={`btn-delete-${type}-${i}`}
                    className="m-color-red_opacity_0_4"
                    aria-label="delete incorrect contact"
                    onClick={() => deleteContact(id)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </InputAdornment>
              }
              fullWidth
              disabled
            />
          );
        })}

        <TextField
          inputProps={{ id: `contact-input-${type}` }}
          inputRef={ref}
          className="mt-20"
          label={`Adicionar novo ${label.toLowerCase()}`}
          variant="outlined"
          fullWidth
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  id={`btn-create-${type}`}
                  className="m-color-green"
                  aria-label={"add new contact"}
                  onClick={() => addContact(type, ref)}
                >
                  <CreateIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </div>
    );
  };

  const setEmpty = () => {
    if (emailList.length === 0) {
      setEmailList([]);
    }
    if (mobileList.length === 1) {
      setMobileList([]);
    }
    if (wireList.length === 1) {
      setWireList([]);
    }
  };

  useEffect(() => {
    const email = [];
    const mobile = [];
    const wire = [];

    contactDisplay.map((c) => {
      switch (c.data_type) {
        case "mobile":
          mobile.push(c);
          break;
        case "wired":
          wire.push(c);
          break;
        case "email":
          email.push(c);
          break;
        default:
          break;
      }

      setEmailList(email);
      setMobileList(mobile);
      setWireList(wire);
    });
  }, [contactDisplay]);

  return (
    <>
      <Tabs
        centered
        indicatorColor="primary"
        scrollButtons="on"
        variant="fullWidth"
        value={currentTab}
        onChange={handleChange}
        aria-label="Abas com dados básicos"
      >
        <Tab key={0} label="Precatório" />
        <Tab key={1} label="Contatos" />
      </Tabs>

      <div hidden={currentTab != 0}>
        <Table>
          <TableBody>
            {createRow("numero_precatorio")}
            {createRow("numero_oficio")}
            {createRow("tribunal")}
            {createRow("devedor")}
            {createRow("regime_devedor")}
            {createRow("ano_vencimento")}
            {createRow("valor", formatCurrency)}
            {createRow("assunto")}
            {createRow("unidade_origem")}
            {createRow("uf_origem")}
          </TableBody>
        </Table>

        {eventos.length > 0 && (
          <>
            <br />
            <div className="crm-trade-basic-title mb-15">MOVIMENTAÇÕES</div>

            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className="card-table card-modal-field-header">
                    Data
                  </TableCell>

                  <TableCell className="card-table card-modal-field-header">
                    Movimentação
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {eventos.map((event, i) => {
                  return (
                    <TableRow key={i} className="card-modal-field">
                      <TableCell className="card-table card-modal-field-header">
                        {event.data}
                      </TableCell>

                      <TableCell>
                        <div>{event.texto}</div>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </>
        )}

        {documentos.length > 0 && (
          <div className="crm-trade-basic-docs-area">
            <br />

            <div className="crm-trade-basic-title mb-15">
              DOCUMENTOS DISPONÍVEIS
            </div>

            {documentos.map(({ title, url }) => (
              <Button
                key={url}
                variant="outlined"
                size="large"
                startIcon={<DescriptionIcon />}
                onClick={() => window.open(url)}
                fullWidth
              >
                {sanitizeDocumentName(title)}
              </Button>
            ))}
          </div>
        )}
      </div>

      <div
        hidden={currentTab != 1}
        className="crm-trade-contacts-container p-30 pt-5"
      >
        <p className="crm-trade-contacts-credor">{nome_credor}</p>

        {contactsData(wireList, "wired", wireRef)}
        {contactsData(mobileList, "mobile", mobileRef)}
        {contactsData(emailList, "email", emailRef)}

        <Snackbar
          open={contactUpdated}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setContactUpdated(false)}
        >
          <Alert message="Contato atualizado com sucesso!" />
        </Snackbar>

        <Snackbar
          open={updateError}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setUpdateError(false)}
        >
          <Alert
            message="Não conseguimos deletar o contato!"
            severity="error"
          />
        </Snackbar>
      </div>
    </>
  );
};
